module.exports = __webpack_public_path__ + "media/notice.a68b1b40.mp3";